export function formatARS(value: number) {
  return `AR$ ${value.toLocaleString('es-AR')}`;
}
